export default "__VITE_ASSET__4c7652cd__"